import React, { JSX, FC } from "react";
import InfoModal from "components/ui/modals/InfoModal/InfoModal";

type RequirementType = {
  title: string;
  content: React.ReactNode;
};

interface IMediaRequirementsModalProps {
  isOpen: boolean;
  onCancelHandler: () => void;
}

const photoRequirements: RequirementType[] = [
  {
    title: "Формат:",
    content: "JPEG, JPG, PNG, HEIC, WEBP",
  },
  {
    title: "Размер:",
    content: "до 10 МБ",
  },
  {
    title: "Разрешение:",
    content: "900 x 900 до 4320 x 7680 пикселей",
  },
  {
    title: "Соотношение сторон:",
    content: "вертикальное 3:4, квадратное 1:1",
  },
];

const MediaRequirementsModal: FC<IMediaRequirementsModalProps> = ({ isOpen, onCancelHandler }): JSX.Element => {
  const renderRequirementsBlock = (requirements: RequirementType[]) => {
    return (
      <div>
        {requirements.map(({ title, content }: RequirementType, idx: number) => (
          <div key={idx} className="pr-14">
            <p className="flex mb-2">
              <span className="font-bold">{title}</span>
              <span className="ml-1">{content}</span>
            </p>
          </div>
        ))}
      </div>
    );
  };

  return (
    <InfoModal
      isOpen={isOpen}
      onClose={onCancelHandler}
      title="Требования для загрузки медиафайлов"
    >
      {renderRequirementsBlock(photoRequirements)}
    </InfoModal>
  );
};

export default MediaRequirementsModal;
